import { withDefault, StringParam } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SortDir,
  BaseellaStatus,
  SchemaFilterType,
  BaseellaStatusTitle,
  BenificiaryType,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: 'Transaction identifier',
    hidden: true,
    sortable: true,
  },
  {
    name: 'transferDate',
    label: 'Transfer Date',
    sortable: true,
  },
  {
    name: 'currencyId',
    label: 'Currency',
    sortable: true,
  },
  {
    name: 'baseellaStatus',
    label: 'Status',
    sortable: true,
  },
  {
    name: 'sum',
    label: 'Amount',
    sortable: true,
  },
  {
    name: 'senderAccountNumber',
    label: 'Sender account',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'acceptedOut',
    label: 'Accepted Out',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'paymentType',
    label: 'Payment type',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'recipientAccountNumber',
    label: 'Account/IBAN',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'pspPartnerAccountNumber',
    label: 'Partner PSP Account',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'documentNumber',
    label: 'Document number',
    hidden: true,
    sortable: true,
    filterModalPlacement: 'right',
  },

  {
    name: 'chargeType',
    label: 'Charges type',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'info',
    label: 'Payment details',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryFullName',
    label: 'Full name',
    hidden: true,
    headerRender: () => 'Beneficiary',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryCountry',
    label: 'Country',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryAddress',
    label: 'Beneficiary Address',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryType',
    label: 'Beneficiary Type',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryBIC',
    label: 'Beneficiary BIC',
    hidden: true,
    headerRender: () => 'Beneficiary bank',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryBankCountry',
    label: 'Bank Country',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryBankCorrespondentAccount',
    label: 'Bank Сorr. Account',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'benificiaryBankName',
    label: 'Bank Name',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'riskScore',
    label: 'AML: Weighted transaction score',
    hidden: true,
    headerRender: () => 'AML',
    filterModalPlacement: 'right',
    sortable: true,
  },

  {
    name: 'intermediaryBankBIC',
    label: 'BIC',
    hidden: true,
    headerRender: () => 'Intermediary Bank',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'intermediaryBankAddress',
    label: 'Intermediary Bank Address',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'intermediaryBankCountry',
    label: 'Intermediary Bank country',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'intermediaryBankName',
    label: 'Intermediary Bank Name',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'deletedAt',
    label: '',
    hidden: true,
  },
  {
    name: 'values',
    label: '',
    hidden: true,
  },
];

export const columnsLabels = {
  id: 'Transaction identifier',
  transferDate: 'Date created',
  transferDateFrom: 'Date created From',
  transferDateTo: 'Date created To',
  acceptedOut: 'Date Accepted',
  currencyId: 'Currency',
  baseellaStatus: 'Status',
  senderAccountNumber: 'Sender account',
  paymentType: 'Payment type',
  recipientAccountNumber: 'Account/IBAN',
  info: 'Payment details',
  pspPartnerAccountNumber: 'Partner PSP Account',
  benificiaryFullName: 'Benificiary full name',
  benificiaryCountry: 'Benificiary country',
  benificiaryType: 'Benificiary type',
  benificiaryBIC: 'Beneficiary BIC',
  benificiaryBankName: 'Benificiary Bank Name',
  intermediaryBankName: 'Intermediary Bank Name',
  intermediaryBankBIC: 'Intermediary Bank BIC',
  documentNumber: 'Document number',
};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  // acceptedOut: {
  //   value: CustomStringParam,
  //   type: SchemaFilterType.DATE,
  // },
  benificiaryBIC: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  intermediaryBankName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  documentNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  intermediaryBankBIC: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  benificiaryBankName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  benificiaryFullName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  benificiaryCountry: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  id: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  baseellaStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  benificiaryType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  senderAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  paymentType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  recipientAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pspPartnerAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  info: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const expandableColumns = [
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'status',
    label: 'Status',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'debitAccountId',
    label: 'Debit account No.',
  },
  {
    name: 'debitAccount',
    label: 'Debit account description',
  },
  {
    name: 'creditAccountId',
    label: 'Credit account No.',
  },
  {
    name: 'creditAccount',
    label: 'Credit account description',
  },

  {
    name: 'documentNumber',
    label: 'Doc. N',
  },
];

export const filtersSchema = [
  {
    name: 'currencyId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'benificiaryType',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'benificiaryType',
        title: 'Individual',
        value: BenificiaryType.INDIVIDUAL,
      },
      {
        name: 'benificiaryType',
        title: 'Corporate',
        value: BenificiaryType.CORPORATE,
      },
    ],
  },
  {
    name: 'baseellaStatus',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.DRAFT,
        value: BaseellaStatus.DRAFT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NONE,
        value: BaseellaStatus.NONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NEW,
        value: BaseellaStatus.NEW,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.HELD,
        value: BaseellaStatus.HELD,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.SENT,
        value: BaseellaStatus.SENT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.PROC,
        value: BaseellaStatus.PROC,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ARCH,
        value: BaseellaStatus.ARCH,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REFUNDED,
        value: BaseellaStatus.REFUNDED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REV,
        value: BaseellaStatus.REV,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML,
        value: BaseellaStatus.AML,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_INFO,
        value: BaseellaStatus.AML_INFO,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_REJ,
        value: BaseellaStatus.AML_REJ,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_DONE,
        value: BaseellaStatus.AML_DONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REJECTED,
        value: BaseellaStatus.REJECTED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NOT_SIGNED,
        value: BaseellaStatus.NOT_SIGNED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_SEND,
        value: BaseellaStatus.READY_TO_SEND,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_PSP,
        value: BaseellaStatus.READY_TO_PSP,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ACCP_OUT,
        value: BaseellaStatus.ACCP_OUT,
      },
    ],
  },
  {
    name: 'transferDate',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
  // {
  //   name: 'acceptedOut',
  //   type: FilterType.DATE,
  //   pickerType: 'twoPickers',
  // },
  {
    name: 'recipientAccountNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter Account/IBAN...',
  },
  {
    name: 'benificiaryBIC',
    type: FilterType.TEXT,
    placeholder: 'Enter BIC...',
  },
  {
    name: 'id',
    type: FilterType.TEXT,
    placeholder: 'Enter identifier...',
  },
  {
    name: 'info',
    type: FilterType.TEXT,
    placeholder: 'Enter payment details...',
  },
  {
    name: 'senderAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'benificiaryFullName',
    type: FilterType.TEXT,
    placeholder: 'Enter name...',
  },
  {
    name: 'intermediaryBankName',
    type: FilterType.TEXT,
    placeholder: 'Enter bank name...',
  },
  {
    name: 'benificiaryBankName',
    type: FilterType.TEXT,
    placeholder: 'Enter bank name...',
  },
  {
    name: 'intermediaryBankBIC',
    type: FilterType.TEXT,
    placeholder: 'Enter BIC...',
  },
  {
    name: 'pspPartnerAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'benificiaryCountry',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by country...',
  },

  {
    name: 'paymentType',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter payment type...',
  },
  {
    name: 'documentNumber',
    type: FilterType.TEXT,
    placeholder: 'Enter document number...',
  },
];
